import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import {Helmet} from 'react-helmet'
import api from "../../services/api"


class MeusDadosUser extends Component {

  state = {
    error:null,
    email:null,
    telefone1: null,
    telefone2:null,
    cpf:null,
    nomecompleto:null,

  }

  async componentDidMount(){
    document.getElementById("meusdadosmenu").classList.toggle("bg-light");

    const response = await api.post("/user/details");
    
    this.setState({
      email:response.data.success.email,
    telefone1: response.data.success.dados_users.telefone1,
    cpf:response.data.success.dados_users.cpf,
    nomecompleto:response.data.success.dados_users.nomecompleto,


    })

  }
   
    togglemenu = ()=> {
        document.getElementById("sidebar").classList.toggle("active");
        document.getElementById("content").classList.toggle("active");
    }

    onSubmit = async e => {
      e.preventDefault();
      const { telefone1, telefone2, password} = this.state;

      if(!telefone1){
          this.setState({
              error:"Alguns dados estão em branco",
              success:null
            })
      }else{
        const response = await api.post("/user/edit", { telefone2, telefone1, password});
        this.setState({
          error:null,
          success:"Seus dados foram atualizados."
        })

      }

      


    }

  render() {
  

    return (
        
      <React.Fragment>
        <Header />
        <Helmet>
            <title>Painel | Faculdade Olga Mettig</title>
        </Helmet>

<div class="page-content white" id="content">
  

  <button id="sidebarCollapse" onClick={this.togglemenu} type="button" class="btn btn-light bg-white rounded-pill shadow-sm px-4 mb-4"><i class="fa fa-bars mr-2"></i><small class="text-uppercase font-weight-bold">Toggle</small></button>
  
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/user">Pagina Inicial</a></li>
        </ol>
    </nav>
 
  <div class="separator"></div>
  <div class="row text-black contentp">
    <div class="col-lg-7">
    
    




<form class="text-center  border-light p-6" onSubmit={this.onSubmit}>

      <h2>Meus Dados</h2>

     <br></br>
     {this.state.error && <h6><p>{this.state.error}</p></h6>}
    {this.state.success && <h6><p>{this.state.success}</p></h6>}
    <div class="form-row mb-4">
   
        <div class="col">
       
            <input type="text" defaultValue={this.state.nomecompleto}  onChange={e => this.setState({ nome: e.target.value })} class="form-control" placeholder="Nome"  readOnly/>
        </div>
    </div>

    <input type="text" defaultValue={this.state.cpf} onChange={e => this.setState({ cpf: e.target.value })} class="form-control mb-4" placeholder="Seu CPF" readOnly />

    <input type="email" defaultValue={this.state.email} onChange={e => this.setState({ email: e.target.value })}  class="form-control mb-4" placeholder="E-mail" readOnly />


    <input type="password" defaultValue={this.state.password} onChange={e => this.setState({ password: e.target.value })} class="form-control" placeholder="Password" aria-describedby="defaultRegisterFormPasswordHelpBlock" />
    <small id="defaultRegisterFormPasswordHelpBlock" class="form-text text-muted mb-4">
       
    </small>

   
    <input type="text" defaultValue={this.state.telefone1} onChange={e => this.setState({ telefone1: e.target.value })} class="form-control mb-4" placeholder="Telefone" aria-describedby="defaultRegisterFormPhoneHelpBlock" />
    <input type="text" defaultValue={this.state.telefone2} onChange={e => this.setState({ telefone2: e.target.value })} class="form-control mb-4" placeholder="Telefone 2" aria-describedby="defaultRegisterFormPhoneHelpBlock" />


   
 
    <button class="btn btn-success my-4 btn-block" type="submit">Atualizar Dados</button>

   
   
    

</form>




















    </div>
    
  </div>

</div>


      </React.Fragment>
       
    );
  }
}

export default withRouter(MeusDadosUser);


// WEBPACK FOOTER //
// ./src/pages/User/meusdados.js